import React, { useState } from "react";
import { Button } from "@mui/material";
import { FormControl, FormControlLabel, TextField } from "@mui/material";
import { FormLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import UserRepository from "../../Repository/UserRepository";
import { ClipLoader } from "react-spinners";

function Address({ user, onSuccess, onClose }) {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    street: user?.address?.street || "",
    city: user?.address?.city || "",
    terms: user?.address?.terms || "",
    selectedPhone: user?.address?.selectedPhone || "",
    phoneOne: user?.address?.phoneOne || "",
    phoneTwo: user?.address?.phoneTwo || "",
  });

  const handleInput = (e) => {
    const { value, name } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleUpdate = async () => {
    try {
      setLoading(true);
      let { data } = await UserRepository.usersModel({
        request: {
          method: "updateUser",
          data: {
            _id: user._id,
            user: {
              ...user,
              address: state,
            },
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        localStorage.setItem("terms", state.terms);
        localStorage.setItem("address", state.street + " " + state.city);
        if (state.selectedPhone == "phoneTwo") {
          localStorage.setItem("phone", state.phoneTwo);
        } else if (state.selectedPhone == "phoneOne") {
          localStorage.setItem("phone", state.phoneOne);
        } else if (state.selectedPhone == "bothNumbers") {
          localStorage.setItem("p1", state.phoneOne);
          localStorage.setItem("p2", state.phoneTwo);
        }
        onSuccess(state);
      }
      onClose();
    } catch (err) {
      console.log("err", err);
      setLoading(false);
      onClose();
    }
  };
  return (
    <Stack gap={2}>
      <Typography variant="h6" sx={{ color: "#4EAF51" }}>
        Enter Shipping Details!
      </Typography>

      <TextField
        type="text"
        size="small"
        name="street"
        label="Street Address"
        value={state.street}
        fullWidth
        onChange={handleInput}
      />

      <TextField
        label="City"
        size="small"
        name="city"
        value={state.city}
        type="text"
        fullWidth
        onChange={handleInput}
      />

      <TextField
        size="small"
        label="Terms and Conditions"
        name="terms"
        value={state.terms}
        type="text"
        fullWidth
        onChange={handleInput}
      />

      <FormControl size="small">
        <FormLabel>Select Phone Number</FormLabel>
        <RadioGroup
          row
          name="selectedPhone"
          value={state.selectedPhone}
          onChange={handleInput}
        >
          <FormControlLabel
            size="small"
            value="phoneOne"
            control={<Radio />}
            label="Phone 1"
          />
          <FormControlLabel
            size="small"
            value="phoneTwo"
            control={<Radio />}
            label="Phone 2"
          />
          <FormControlLabel
            size="small"
            value="bothNumbers"
            control={<Radio />}
            label="Both"
          />
        </RadioGroup>
      </FormControl>

      <TextField
        size="small"
        label="Phone 1"
        type="text"
        name="phoneOne"
        value={state.phoneOne}
        fullWidth
        onChange={handleInput}
      />
      <TextField
        size="small"
        label="Phone 2"
        name="phoneTwo"
        type="text"
        value={state?.phoneTwo}
        fullWidth
        onChange={handleInput}
      />

      {loading && (
        <Stack width="100%" alignItems="center" justifyContent="center">
          <ClipLoader loading={true} color="#4eaf51" size={32} />
        </Stack>
      )}
      {!loading && (
        <Stack direction="row" justifyContent="space-evenly" spacing={4}>
          <Button fullWidth variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button fullWidth variant="contained" onClick={handleUpdate}>
            Save
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

export default Address;
